var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpFinder',{ref:"finder",staticClass:"channelCode",attrs:{"id":"1","show-tool-bar":false,"no-selection":true,"url":{
    data: _vm.requestUrl + '/customer/welcome-msg/get-list'
  },"title":"数据","columns":_vm.columns,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }